import React, { memo, useCallback } from 'react'
import { Form, Formik } from 'formik'
import { PartnerDriverProfileFormContent } from './PartnerDriverProfileFormContent'
import { partnerDriverProfileFormValidator } from './PartnerDriverProfileForm.validator'
import type { PartnerDriverProfileFormValues } from './PartnerDriverProfileForm.interface'

interface Props {
  initialValues: PartnerDriverProfileFormValues
  isSaving: boolean
  /** Fields disabled and Save not rendered. */
  isReadOnly: boolean
  onSubmit(values: PartnerDriverProfileFormValues): void
}

const PartnerDriverProfileFormComponent = ({
  initialValues,
  isSaving,
  isReadOnly,
  onSubmit,
}: Props) => {
  const handleSubmit = useCallback(
    (values: PartnerDriverProfileFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<PartnerDriverProfileFormValues>
      initialValues={initialValues}
      validationSchema={partnerDriverProfileFormValidator}
      // A refetch after save (or another write) reseeds the fields from the server.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form>
        <PartnerDriverProfileFormContent isSaving={isSaving} isReadOnly={isReadOnly} />
      </Form>
    </Formik>
  )
}

export const PartnerDriverProfileForm = memo(PartnerDriverProfileFormComponent)
